const localePt = {
  SC_COURSE_TAB_TITLE: `Cursos`,
  SC_EMPTY_STATE_TITLE: `Aún no has guardado un curso`,
  SC_EMPTY_STATE_MESSAGE_PT1: `Cuando veas un curso que te guste, haz clic en el ícono`,
  SC_EMPTY_STATE_MESSAGE_PT2: `para guardarlo e inscribirte luego.`,
  SC_GO_TO_CATALOG: `Ir al catálogo`,
};
export default localePt;
